import React from 'react';
import { Card, Notification } from "rbx";
import cep from 'cep-promise';
import Controls from '../../components/Controls/Controls';

const PdvForm = (props) => {
  const { 
    newRecord=false, 
    editRecord=false, 
    status, 
    stateButton, 
    values, 
    setValues,
    handleInputChange, 
    handleSubmit, 
    handleClickBack } = props;

  const findAddressByCep = async (e) => {
    e.preventDefault();
    try {
      if (values.address.zipCode && values.address.zipCode.trim().length===9) {
        const address = await cep(values.address.zipCode);
        setValues({
          ...values, 
          address: {
            ...values.address,
            street: address.street.toUpperCase(),
            district: address.neighborhood.toUpperCase(),
            city: address.city.toUpperCase()
          }
        });
      } else {
        setValues({
          ...values, 
          address: {
            ...values.address,
            street: '',
            district: '',
            city: '',
            number: ''
          }
        });
      }
    } catch(e) {
      console.log('Error: ', e);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>{newRecord ? 'Registrar Usuário PDV' : 'Editar dados do PDV - Revendedor'}</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Controls.CpfCnpjField 
            label="CPF ou CNPJ"
            name="cpf_cnpj"
            placeholder='12.345.678/0001-01'
            value={values.cpf_cnpj}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.TextField 
            label="Nome"
            name="name"
            placeholder='Nome completo ou Razão social'
            value={values.name}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Email"
            name="email"
            placeholder='nome@email.com'
            value={values.email}
            onChange={handleInputChange}
            required
          />
          <Controls.TextFieldMask
            label="Data de Nascimento"
            name="birthday"
            mask='99/99/9999'
            placeholder='__/__/____'
            value={values.birthday}
            onChange={handleInputChange}
            required
          />
          <Controls.PhoneField
            label="Telefone"
            name="phone"
            placeholder='(__) ____-____'
            value={values.phone}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Percentual de Desconto (%)"
            name="discount"
            placeholder='10'
            value={values.discount}
            onChange={handleInputChange}
            required
            maxLength='2'
          />
          <Controls.SelectField
            label="PDV Parceiro ?"
            name="isPartner"
            value={values.isPartner}
            onChange={handleInputChange}
            options={[{value: '2', description: 'NÃO'}, {value: '1', description: 'SIM'}]}
          />
        </Card.Content>
      </Card>
      <br />
      <Card>
        <Card.Content>
          <Controls.ZipCodeField 
            label="CEP"
            name="address|zipCode"
            placeholder='_____-___'
            value={values.address.zipCode}
            onChange={handleInputChange}
            onClick={findAddressByCep}
            required
          />
          <Controls.TextField 
            label="Logradouro"
            name="address|street"
            placeholder='AV, RUA, TRAVESSA ...'
            value={values.address.street}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Número"
            name="address|number"
            value={values.address.number}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Bairro"
            name="address|district"
            value={values.address.district}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Município"
            name="address|city"
            placeholder='FORTALEZA'
            value={values.address.city}
            onChange={handleInputChange}
            required
          />
        </Card.Content>
      </Card>
      <br />
      <Card>
        <Card.Content>
          <Controls.PasswordField 
            label={newRecord ? 'Senha do PDV' : 'Senha do ADM'}
            name="password"
            value={values.password}
            onChange={handleInputChange}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={handleClickBack} 
            buttonState={stateButton} 
            buttonName={newRecord ? 'Registrar' : 'Atualizar'}
          />
        </Card.Content>
      </Card>
      {
        (editRecord) &&
        <>
          <br />
          <Card>
            <Card.Content>
              { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
              <Controls.PasswordField 
                label="Nova senha do PDV"
                name="passwordNew"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordNew}
                onChange={handleInputChange}
              />
              <Controls.PasswordField 
                label="Confirme a nova senha"
                name="passwordConfirmation"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordConfirmation}
                onChange={handleInputChange}
              />
              <Controls.ActionButtons
                linkName="Cancelar" 
                handleClickBack={handleClickBack}
                buttonState={stateButton} 
                buttonName='Atualizar'
              />
            </Card.Content>
          </Card>
        </>
      }
    </form>
  )

}

export default PdvForm;
